const common = {
  "nav.categories": "Catégories",
  "nav.guides": "Guides",
  "nav.about": "À propos",
  "nav.faq": "FAQ",
  "nav.cta": "Acheter maintenant",
  "nav.home": "Accueil",
  "nav.shoppingGuide": "Guide d'achat",

  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.es": "Español",
  "lang.pt": "Português",

  "hero.badge": "Centre de ressources Basetao Spreadsheet",
  "hero.title": "Basetao Spreadsheet : produits, vendeurs et guides d'achat",
  "hero.subtitle":
    "Un centre de ressources indépendant et épuré qui vous aide à explorer les catégories de produits Basetao, les liens sélectionnés et les conseils d'achat pratiques — tout au même endroit.",
  "hero.cta1": "Basetao Spreadsheet",
  "hero.cta2": "Acheter maintenant",
  "hero.dropdownLabel": "Aller à une catégorie",

  "cat.dropdownPlaceholder": "Choisir une catégorie…",

  "catSection.eyebrow": "Parcourir le spreadsheet",
  "catSection.title": "Explorer les catégories",
  "catSection.subtitle":
    "Parcourez les catégories de produits les plus populaires du Basetao Spreadsheet et accédez directement aux articles que vous recherchez.",
  "catSection.shopNow": "Acheter",

  "cat.shoes": "Chaussures",
  "cat.hoodies": "Hoodies / Sweats",
  "cat.tshirts": "T-shirts",
  "cat.jackets": "Vestes",
  "cat.pants": "Pantalons / Shorts",
  "cat.headwear": "Couvre-chefs",
  "cat.sets": "Ensembles",
  "cat.underwear": "Sous-vêtements",
  "cat.jersey": "Maillots",
  "cat.accessories": "Accessoires",
  "cat.bags": "Sacs",
  "cat.belts": "Ceintures",
  "cat.perfumes": "Parfums",
  "cat.other": "Autres articles",

  "guides.eyebrow": "Guides et ressources",
  "guides.title": "Guides populaires",
  "guides.subtitle":
    "Des articles originaux et pratiques qui expliquent comment utiliser le Basetao Spreadsheet et acheter en toute confiance.",
  "guides.readMore": "Lire le guide",
  "guides.card.badge": "Guide débutant",
  "guides.card.title": "Guide du Basetao Spreadsheet : définition et utilisation",
  "guides.card.excerpt":
    "Un guide clair et accessible qui explique ce qu'est un Basetao Spreadsheet, comment le lire et comment l'utiliser pour trouver des produits, des vendeurs et de meilleurs prix.",

  "about.eyebrow": "Qu'est-ce que c'est ?",
  "about.title": "Qu'est-ce qu'un Basetao Spreadsheet ?",
  "about.p1":
    "Un Basetao Spreadsheet est une liste partagée et organisée de produits, de liens, de vendeurs et de notes, rassemblée par des acheteurs qui utilisent Basetao pour commander sur des places de marché chinoises et se faire livrer à l'international. Au lieu de tout chercher de zéro, vous partez d'une sélection d'articles que d'autres acheteurs ont déjà trouvés et vérifiés.",
  "about.p2":
    "Comme une feuille de calcul est facile à filtrer, trier et partager, c'est un moyen pratique de comparer des produits dans des catégories telles que chaussures, hoodies, t-shirts, vestes, sacs et accessoires, tout en gardant une trace des vendeurs et des notes de contrôle qualité qui comptent au moment de commander.",
  "about.point1.title": "Produits sélectionnés",
  "about.point1.text":
    "Les liens vers des articles précis sont classés par catégorie, pour passer moins de temps à chercher et plus de temps à comparer.",
  "about.point2.title": "Notes vendeur et QC",
  "about.point2.text":
    "Des notes utiles sur les vendeurs et le contrôle qualité vous aident à repérer des options fiables avant de commander.",
  "about.point3.title": "Partageable et à jour",
  "about.point3.text":
    "Les feuilles de calcul sont faciles à partager et à mettre à jour, pour que la liste reste fraîche à mesure que de nouveaux produits et notes sont ajoutés.",

  "features.eyebrow": "Pourquoi l'utiliser",
  "features.title": "Pourquoi utiliser un Basetao Spreadsheet ?",
  "features.subtitle":
    "Quelques raisons pour lesquelles les acheteurs s'appuient sur une feuille de calcul organisée lorsqu'ils commandent via Basetao.",
  "features.f1.title": "Gagner du temps",
  "features.f1.text": "Partez d'une liste prête au lieu de parcourir des dizaines de pages une par une.",
  "features.f2.title": "Comparer facilement",
  "features.f2.text": "Voyez les produits côte à côte selon les catégories, les vendeurs et les prix.",
  "features.f3.title": "Rester organisé",
  "features.f3.text": "Gardez vos choix, notes et détails de contrôle qualité au même endroit.",
  "features.f4.title": "Acheter avec du contexte",
  "features.f4.text":
    "Associez les liens produits aux notes vendeur et QC pour faire des choix plus sûrs.",

  "faq.eyebrow": "FAQ",
  "faq.title": "Questions fréquentes",
  "faq.q1": "Qu'est-ce qu'un Basetao Spreadsheet ?",
  "faq.a1":
    "C'est une liste partagée et organisée de produits, de liens, de vendeurs et de notes que les acheteurs utilisent pour trouver et comparer des articles commandés via Basetao.",
  "faq.q2": "Ce site est-il affilié à Basetao ?",
  "faq.a2":
    "Non. BasetaoSheet.casa est une ressource informative indépendante et n'est pas nécessairement affiliée à Basetao, sauf mention explicite.",
  "faq.q3": "Comment utiliser les catégories de cette page ?",
  "faq.a3":
    "Choisissez une catégorie dans le menu déroulant ou la grille, et vous serez redirigé vers la page produit correspondante sur notre site principal.",
  "faq.q4": "Faut-il un compte pour parcourir ?",
  "faq.a4": "Non, vous pouvez explorer librement les catégories et les guides sans vous inscrire.",
  "faq.q5": "Les prix et les vendeurs sont-ils garantis ?",
  "faq.a5":
    "Les prix, la disponibilité et les détails des vendeurs peuvent changer. Vérifiez toujours la page produit sur le site principal avant de commander.",

  "cta.title": "Prêt à explorer tout le catalogue ?",
  "cta.subtitle": "Parcourez toutes les catégories sur le site principal et trouvez les articles que vous cherchez.",
  "cta.button": "Acheter maintenant",

  "footer.tagline":
    "Basetao Sheet est un centre de ressources indépendant pour le Basetao Spreadsheet, qui aide les acheteurs à explorer produits, catégories et guides.",
  "footer.disclaimer": "Ressource informative indépendante. Pas nécessairement affiliée à Basetao.",
  "footer.explore": "Explorer",
  "footer.resources": "Ressources",
  "footer.legal": "Mentions légales",
  "footer.guide": "Guide du Spreadsheet",
  "footer.home": "Accueil",
  "footer.categories": "Catégories",
  "footer.about": "À propos",
  "footer.faq": "FAQ",
  "footer.rights": "Tous droits réservés.",

  "home.breadcrumb": "Accueil",
  "article.notFound": "Article introuvable",
  "article.faqHeading": "Questions fréquentes",
  "article.conclusionHeading": "En conclusion",

  "notFound.title": "Page introuvable",
  "notFound.subtitle": "La page que vous recherchez n'existe pas ou a peut-être été déplacée.",
};

export default common;